import { ManageMenuFormValue, ManageMenuPhaseOption } from './manage-menu.interfaces';

export function createManageMenuFormValue(): ManageMenuFormValue {
  return {
    menu_name: '',
    menu_url: '',
    menu_code: '',
    order_by: null,
    icon_class: 'fa-bars',
    parent_menu_id: null,
    phase: MANAGE_MENU_DEFAULT_PHASE,
  };
}

export const MANAGE_MENU_PHASE_OPTIONS: readonly ManageMenuPhaseOption[] = [
  { label: 'Phase 1', value: 1 },
  { label: 'Phase 2', value: 2 },
  { label: 'All', value: 3 },
] as const;

export const MANAGE_MENU_DEFAULT_PHASE = 1;
